/**
 * Persistenza del tenant slug in cookie: usato per precompilare il campo
 * Tenant nel form di login. Viene impostato a ogni login tenant e cancellato
 * quando si entra come Host (campo tenant lasciato vuoto).
 */
const TENANT_SLUG_COOKIE = 'offertify_tenant_slug';
const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365;

export function getTenantSlugCookie(): string {
  const match = document.cookie.match(new RegExp(`(?:^|; )${TENANT_SLUG_COOKIE}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : '';
}

export function setTenantSlugCookie(slug: string): void {
  document.cookie = `${TENANT_SLUG_COOKIE}=${encodeURIComponent(slug)}; path=/; max-age=${ONE_YEAR_SECONDS}; SameSite=Lax`;
}

export function clearTenantSlugCookie(): void {
  document.cookie = `${TENANT_SLUG_COOKIE}=; path=/; max-age=0; SameSite=Lax`;
}
